<template>
    <div>
        <b-modal
            ref="login-cadastro"
            size="xl"
            id="modal-consulta-login"
            :body-class="(step==1?'verificao-banner': '')"
            hide-footer
            >
            <div align="center">
                <div :class="'verificacao verificacao-banner align-center justify-content-center flex-column' + (step==1?' d-flex': ' d-none')">
                    <img  @click="step++" class="modal-consulta-login-banner" src="~@/assets/imgs/modal-consulta-login-01.jpg"/>
                </div>
                <div :class="'verificacao verificacao-text-mobile align-center justify-content-center flex-column' + (step==1?' d-flex': ' d-none')">
                    <span><b>⚠ Atenção, Mudança Importante a Caminho! ⚠</b></span>
                    <span>
                        <br>
                        Olá ! Temos uma novidade importante que queremos compartilhar com você. 
                        Para garantir ainda mais a segurança dos nossos usuários, a partir de 15/08/2023, a Consulta Gratuita de Protesto exigirá que você faça o login na Cenprot.
                    </span>
                    <span>
                        <br>
                        Essa é uma maneira de garantirmos que seus dados estarão ainda mais protegidos enquanto você aproveita nossos serviços. 
                        Mas não se preocupe, se ainda não tem uma conta conosco, o processo é super rápido e simples! 🚀

                    </span>
                    <span>
                        <br>
                        👥 Não é cadastrado na Cenprot? É fácil resolver! Convidamos você a se cadastrar gratuitamente. Assim, você poderá continuar aproveitando a Consulta Gratuita de Protesto com total segurança, além de todas as outras vantagens que a Cenprot oferece.
                        
                        <br>
                        <br>
                            Clique no botão abaixo e junte-se a nós agora mesmo! Estamos ansiosos para te receber.

                    </span>
                    <!-- <span><br>Para sua segurança e proteção dos seus dados, para realizar a Consulta Gratuita de Protesto será necessário estar cadastrado no portal da Cenprot Nacional. Caso você já tenha um cadastro, realize o login a seguir.</span> -->
                    <b-button class="btn-continuar-verificacao" @click="step++">Continuar</b-button>
                </div>
                <b-tabs v-show="step==2" content-class="login-cadastr-tabs">
                    <b-tab title="Já sou cadastrado" active>
                        <cardlogin :cardStyle="'cardlogin-modal bg-white'" :pesquisa="true" @loginpesquisa="retorno_login"  />
                    </b-tab>
                    <b-tab title="Cadastro Simplificado">
                        <cadastrosimples @cadastropesquisa="retorno_cadastro" />
                    </b-tab>
                </b-tabs>
            </div>
        </b-modal>
        <b-modal ref="modalErro" title="Atenção">{{msgValidacao}}</b-modal>
        <div class="fale-conosco-content">
            <div class="fale-conosco-card">
                <h4>Fale Conosco</h4>
                <span>Entre em contato</span>
                <button class="btn-fale-consco" @click="enviaEmail">
                    contato@cartoriosdeprotesto.org.br
                    <img class="seta" src="@/assets/imgs/svg/arrow_home_consulta.svg" />
                </button>
            </div>
            <div class="fale-conosco-divider"></div>
            <div class="fale-consco-consulta">
                <span>Consulte seu <strong>CPF ou CNPJ.</strong></span>
                <span>E regularize seu crédito hoje mesmo:</span>
                <div class="fale-conosco-consulta-input">
                    <vue-recaptcha
                        ref="invisibleRecaptcha"
                        :load-recaptcha-script="true"
                        @verify="onVerify"
                        @expired="onExpired"
                        size="invisible"
                        :sitekey="sitekey"
                        badge="bottom"
                    >
                    </vue-recaptcha>
                    <the-mask id="input_cpf_cnpj" :class="validacaoInput?'is-invalid':''" :mask="['###.###.###-##', '##.###.###/####-##']" placeholder="CPF/CNPJ" v-model="cpf_cnpj" pattern="\d*" />
                    <button type="button" class="bt-consultar"  @click="consultaDocumento()">{{ isSmallScreen ? '' : 'Consultar' }}<img class="icone-boltao-consulta" src="@/assets/imgs/svg/lupa_branca.svg"></button>
                </div>
                <span id="errorMsg" ref="inputError" :class="validacaoInput?'d-flex':''">*Documento inválido</span>
        </div>
        </div>
    </div>
</template>
<script>
import { TheMask } from "vue-the-mask";
import VueRecaptcha from "vue-recaptcha";
import cardlogin from '../login/card_login';
import cadastrosimples from "../cadastro/simples";
export default {
    components: {TheMask,VueRecaptcha,cardlogin,cadastrosimples},
    props: {},
    data() {
      return {
        mobile: window.innerWidth < 1200,
        loading: false,
        captchaToken: '',
        sitekey: process.env.VUE_APP_sitekeyRecaptchaInvisivel,
        cpf_cnpj:'',
        msgValidacao:'',
        validacaoInput: false,
        step:2,
      }
    },
    methods: {
        showModalError(error){
            this.msgValidacao = error;
            this.$refs["modalErro"].show();
        },
        enviaEmail() {
            this.$router.push({name: "atendimento"});
        },
        validar(documento) {
            documento = documento.replaceAll('.','');
            documento = documento.replaceAll('-','');
            documento = documento.replaceAll('/','');
            let len = documento.length;
            return len == 11 || len == 14 ? true : false;
        },
        validarCPF(documento) {
            documento = documento.replaceAll('.','');
            documento = documento.replaceAll('-','');
            var Soma;
            var Resto;
            Soma = 0;
            if (documento == "00000000000") return false;
            for (let i=1; i<=9; i++)
                Soma = Soma + parseInt(documento.substring(i-1, i)) * (11 - i);
            Resto = (Soma * 10) % 11;
            if ((Resto == 10) || (Resto == 11))  Resto = 0;
            if (Resto != parseInt(documento.substring(9, 10)) ) return false;
            Soma = 0;
            for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(documento.substring(i-1, i)) * (12 - i);
            Resto = (Soma * 10) % 11;
            if ((Resto == 10) || (Resto == 11))  Resto = 0;
            if (Resto != parseInt(documento.substring(10, 11) ) ) return false;
            return true;
        },
        validarCNPJ(str) {
            str = str.replaceAll('.','');
            str = str.replaceAll('-','');
            str = str.replaceAll('/','');
            let cnpj = str;
            var numeros, digitos, soma, i, resultado, pos, tamanho, digitos_iguais;
            digitos_iguais = 1;
            if (cnpj.length < 14 && cnpj.length < 15)
                return false;
            for (let i = 0; i < cnpj.length - 1; i++)
                if (cnpj.charAt(i) != cnpj.charAt(i + 1))
            {
                digitos_iguais = 0;
                break;
            }
            if (!digitos_iguais)
            {
                tamanho = cnpj.length - 2
                numeros = cnpj.substring(0,tamanho);
                digitos = cnpj.substring(tamanho);
                soma = 0;
                pos = tamanho - 7;
                for (i = tamanho; i >= 1; i--) {
                    soma += numeros.charAt(tamanho - i) * pos--;
                    if (pos < 2)
                        pos = 9;
                }
                resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
                if(resultado != digitos.charAt(0))
                    return false;
                tamanho = tamanho + 1;
                numeros = cnpj.substring(0,tamanho);
                soma = 0;
                pos = tamanho - 7;
                for (i = tamanho; i >= 1; i--) {
                    soma += numeros.charAt(tamanho - i) * pos--;
                    if (pos < 2)
                        pos = 9;
                }
                resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
                if(resultado != digitos.charAt(1))
                    return false;
                return true;
            }
            else
                return false;
        },
        validarConsulta(documento){
            if(!this.validar(documento)) throw "CPF OU CNPJ INVALIDO!";
            if(documento.length == 11)
                if(!this.validarCPF(documento)) throw 'CPF INVÁLIDO';
            
            if(documento.length == 14){
                let documentoTronco = documento.substr(0,8)
                if(!this.validarCNPJ(documento)) throw 'CNPJ INVÁLIDO';
                else if(documentoTronco == '00360305') throw 'Consulta Bloqueada ';
            }
            return true;
        },
        consultaDocumento(){
            this.loading = true;
            this.validacaoInput = false;
            this.$root.isLogged().then( res => {
                setTimeout(() => {                    
                    let documento = this.cpf_cnpj;
                    try {
                        let validacao = this.validarConsulta(documento);
                        
                        if(validacao) this.$router.push({ name: 'consulta', params: { documento: documento, captcha: this.captchaToken, totem: false } });
                    } catch (error) {
                        this.validacaoInput = true;
                        this.showModalError(error);
                        return false
                    }
                }, 1000)  
            }).catch(() => {
                this.$refs["login-cadastro"].show();
            })         
        },
        retorno_login(res){
            if(res.resposta){
                this.loading = true;
                this.$router.push({ name: 'consulta', params: { documento: this.cpf_cnpj, totem: false} });
            }
        },
        retorno_cadastro(res){
            if(res.resposta){
                this.loading = true;
                this.$router.push({ name: 'consulta', params: { documento: this.cpf_cnpj, totem: false} });
            }
        },
        onVerify: function(response) {
            this.captchaToken = response;
            this.resetRecaptcha();
        },
        onExpired: function() {
            this.$refs.invisibleRecaptcha.reset();
        },
        resetRecaptcha() {
            this.$refs.invisibleRecaptcha.reset();
        },
    },
    computed:{
        isSmallScreen(){
            return window.innerWidth < 600
        }
    }
}
</script>
<style scoped>
#errorMsg{display: none;color: #1ACEB5;position: absolute;font: normal normal 100 16px/20px 'Kanit' !important;margin-top: 88px;}
#fale-conosco {
    display: flex;
    width: 100%;
    padding: 84px 0px 131px 0px;
    background: var(--dark-gray-color);
    justify-content: center;
}
#fale-conosco .fale-conosco-content {
    display: flex;
    max-width: 1126px;
    width: 100%;
    height: 128px;
}
#fale-conosco .fale-conosco-content .fale-conosco-card {
    width: 265px;
}
#fale-conosco .fale-conosco-content .fale-conosco-card h4{
    font-family: 'Kanit', sans-serif;
    font-size: 20px;
	line-height: 37px;
	font-weight: 600;
	letter-spacing: -1%;
    color:var(--secondary-color);
    margin:0;
    text-transform: none;
}

#fale-conosco .fale-conosco-content .fale-conosco-card span {
    font-family: 'Kanit', sans-serif;
    font-size: 15px;
	font-weight: 200;
	letter-spacing: -1%;
    color:var(--navbar-gray-color);
    text-transform: none;
}
#fale-conosco .fale-conosco-content .fale-conosco-card button.btn-fale-consco {
    background-color: var(--secondary-color);
    color: #FFFFFF;
    border-radius: 50px;
    border: none;
    font-family: 'Kanit', sans-serif;
    font-size: 16px;
	font-weight: 300;
	letter-spacing: -1%;
    padding: 0px 22px 5px 26px;
    display: flex;
    height: 43px;
    align-items: center;
    position: relative;
    left: -19px;
    top: 22px;
}
#fale-conosco .fale-conosco-content .fale-conosco-card button.btn-fale-consco .seta {
    margin-left:14px;
    margin-top:4px;
}
#fale-conosco .fale-conosco-content .fale-conosco-divider {
    position: relative;
    width: 1.5px;
    height: 140px;
    background-color: #AFBECB;
    margin-top: -9px;
    margin-left: 72px;
    margin-right: 89px;
}
#fale-conosco .fale-conosco-content .fale-consco-consulta {
    width: 100%;
    display: flex;
    flex-flow: column;
    padding-right: 15px;
}
#fale-conosco .fale-conosco-content .fale-consco-consulta span {
    font-family: 'Kanit', sans-serif;
    font-size: 15px;
	font-weight: 200;
	letter-spacing: -1%;
    color:var(--navbar-gray-color);
    text-transform: none;
}
#fale-conosco .fale-conosco-content .fale-consco-consulta span strong {
	font-weight: 500;
}
#fale-conosco .fale-conosco-content .fale-consco-consulta .fale-conosco-consulta-input {
    display: flex;
    margin-left: -20px;
    margin-top: 22px;
}
#fale-conosco .fale-conosco-content .fale-consco-consulta .fale-conosco-consulta-input #input_cpf_cnpj:focus{outline: none;}
#fale-conosco .fale-conosco-content .fale-consco-consulta .fale-conosco-consulta-input #input_cpf_cnpj{
	height: 44px;
	width: 100%;
	border: none;
	border-radius: 40px;
	background: #ffffff;
	color: var(--input-field-gray-color);
	padding-left: 20px;
	font-family: 'Kanit', sans-serif;
	font-size: 20px;
	font-weight: 200;
    letter-spacing: 5%;
}
#fale-conosco .fale-conosco-content .fale-consco-consulta .fale-conosco-consulta-input #input_cpf_cnpj::placeholder{color: var(--input-field-gray-color);}
#fale-conosco .fale-conosco-content .fale-consco-consulta .fale-conosco-consulta-input .bt-consultar{
	height: 44px;
	width: 151px;
	background-color: var(--primary-color);
	border-radius: 40px;
	padding: 0 !important;
	color: white;
	font-size: 18px;
	font-weight: 400;
	border:none;
	position: relative;
	margin-left: -121px;
}
#fale-conosco .fale-conosco-content .fale-consco-consulta .fale-conosco-consulta-input .bt-consultar img{
	margin-left: 9px;
	margin-top: -3px;
}

@media (max-width: 1200px){
    #fale-conosco .fale-conosco-content{
        padding: 0 40px;
    }
}
    
@media (max-width: 900px){
    #fale-conosco .fale-conosco-content{
        flex-flow: column;
        height: fit-content;
    }
    #fale-conosco .fale-conosco-content .fale-conosco-card{
        height: fit-content;
    }
    #fale-conosco .fale-conosco-content .fale-conosco-divider{
        height: 2px;
        width: 20px;
        margin: 72px 0;
        background: var(--navbar-gray-color);
    }
    #fale-conosco .fale-conosco-content .fale-consco-consulta{
        padding: 0;
    }
}
@media (max-width: 600px){
    #fale-conosco .fale-conosco-content .fale-consco-consulta .fale-conosco-consulta-input .bt-consultar{
        width: 64px;
        margin-left: -32px;
    }
    #fale-conosco .fale-conosco-content .fale-consco-consulta .fale-conosco-consulta-input .bt-consultar img{
        margin: 0;
        margin-bottom: 4px;
    }
}
</style>